var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-col",
    { staticClass: "flex" },
    [
      _c(
        "ib-row",
        [
          _c("ib-col", { staticClass: "mf-head fixed-flex middle inset-16" }, [
            _c("h2", {
              class: { fs2: _vm.$media.l, fs4: !_vm.$media.l },
              domProps: {
                textContent: _vm._s(
                  _vm.$router && _vm.$router.options.isPortal
                    ? _vm.$t("mutual_fund_scanner")
                    : _vm.$t("mutual_fund_search_tool")
                ),
              },
            }),
            _vm.resultsview
              ? _c(
                  "div",
                  { staticClass: "text-end center" },
                  [
                    _c(
                      "ib-button",
                      {
                        staticClass: "mf-edit",
                        attrs: { tone: "accent", appearance: "clear" },
                        on: { click: _vm.refresh },
                      },
                      [
                        _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                          _c("path", {
                            attrs: {
                              d: "M25 2a1 1 0 1 0 0 2c11.61 0 21 9.39 21 21s-9.39 21-21 21A20.99 20.99 0 0 1 12 8.52V15a1 1 0 1 0 2 0V5H4a1 1 0 1 0 0 2h6.7A22.96 22.96 0 0 0 2 25c0 12.69 10.31 23 23 23s23-10.31 23-23S37.69 2 25 2z",
                            },
                          }),
                        ]),
                        _vm._v(" " + _vm._s(_vm.$t("refresh_results"))),
                      ]
                    ),
                    _c(
                      "ib-button",
                      {
                        staticClass: "mf-edit",
                        attrs: { tone: "accent" },
                        on: { click: _vm.startOver },
                      },
                      [_vm._v(_vm._s(_vm.$t("start_over")))]
                    ),
                    _c(
                      "ib-button",
                      {
                        staticClass: "mf-edit",
                        attrs: { tone: "accent" },
                        on: { click: _vm.showForm },
                      },
                      [_vm._v(_vm._s(_vm.$t("edit")))]
                    ),
                    _c(
                      "ib-button",
                      {
                        staticClass: "mf-edit",
                        attrs: { tone: "accent", busy: _vm.downloading },
                        on: { click: _vm.downloadData },
                      },
                      [_vm._v(_vm._s(_vm.$t("download_xls")))]
                    ),
                    _vm.signedIn &&
                    _vm.$router &&
                    !_vm.$router.options.isPortal &&
                    typeof _vm.amSession === "undefined"
                      ? _c(
                          "ib-button",
                          {
                            staticClass: "mf-edit",
                            attrs: { tone: "accent" },
                            on: { click: _vm.logOut },
                          },
                          [_vm._v(_vm._s(_vm.$t("log_out")))]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "ib-row",
        [
          _vm.resultsview
            ? _c(
                "ib-col",
                {
                  staticClass: "fs7 insetx-16 after-8",
                  class: { "insetx-24": !_vm.$media.l },
                },
                [
                  _vm.fields.identifier
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("isin")) +
                            ", " +
                            _vm._s(_vm.$t("cusip")) +
                            ", " +
                            _vm._s(_vm.$t("or")) +
                            " " +
                            _vm._s(_vm.$t("ticker_symbol")) +
                            ":"
                        ),
                      ])
                    : _vm._e(),
                  _vm.fields.identifier
                    ? _c("span", {
                        staticClass: "fg-accent outsetx-8 filter-labels",
                        domProps: {
                          textContent: _vm._s(
                            _vm.fields.identifier.toUpperCase()
                          ),
                        },
                      })
                    : _vm._e(),
                  !_vm.$media.l && _vm.fields.identifier ? _c("br") : _vm._e(),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("investor_residency")) + ":"),
                  ]),
                  _c("span", {
                    staticClass: "fg-accent outsetx-8 filter-labels",
                    domProps: { textContent: _vm._s(_vm.fields.residence) },
                  }),
                  !_vm.$media.l ? _c("br") : _vm._e(),
                  _c("span", [_vm._v(_vm._s(_vm.$t("fund_family")) + ":")]),
                  _c("span", {
                    staticClass: "fg-accent outsetx-8 filter-labels",
                    domProps: { textContent: _vm._s(_vm.fields.fundFamily) },
                  }),
                  !_vm.$media.l ? _c("br") : _vm._e(),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("commission_charged")) + ":"),
                  ]),
                  _c("span", {
                    staticClass: "fg-accent outsetx-8 filter-labels",
                    domProps: { textContent: _vm._s(_vm.fields.transLabel) },
                  }),
                  !_vm.$media.l ? _c("br") : _vm._e(),
                  _c("span", [_vm._v(_vm._s(_vm.$t("fund_type")) + ":")]),
                  _c("span", {
                    staticClass: "fg-accent outsetx-8",
                    domProps: { textContent: _vm._s(_vm.fields.fundType) },
                  }),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("ScanFilters", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.resultsview,
            expression: "!resultsview",
          },
        ],
        ref: "scanFilters",
        on: { onSubmit: _vm.onSubmit },
      }),
      _vm.resultsview
        ? _c("SearchResults", {
            ref: "searchResults",
            attrs: { scanFields: _vm.filters },
            on: { signedIn: _vm.checkSignedIn },
          })
        : _vm._e(),
      _c(
        "ib-row",
        [
          _c("ib-col", [
            _c(
              "div",
              { staticClass: "insetx-16 border-top" },
              [
                _c("p", { staticClass: "fs8 outsety-8" }, [
                  _vm._v("Source: Refinitiv"),
                ]),
                _c("P", { staticClass: "fs8" }, [
                  _vm._v(
                    "The information presented is taken from, or based upon, information obtained from publicly available sources, the completeness and accuracy of which has not been independently verified, and cannot be assured by Interactive Brokers."
                  ),
                ]),
                _c("p", { staticClass: "fs8" }, [
                  _vm._v(
                    "Not all products will be available to all investors due to a number of factors including account type requirements and regional restrictions."
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }